// `lang` is optional and will default to the current user agent locale
export function formatPostDate(date) {
  if (typeof Date.prototype.toLocaleDateString !== "function") {
    return date
  }

  const dateObj = new Date(date)
  const args = [{ day: "numeric", month: "long", year: "numeric" }].filter(
    Boolean,
  )
  return dateObj.toLocaleDateString(...args)
}

// from https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript
export const hashCode = (s = "") => {
  let h = 0
  for (let i = 0; i < s.length; i += 1)
    /* eslint-disable no-bitwise */
    h = (Math.imul(31, h) + s.charCodeAt(i)) | 0
  return h
}

export const numberWithCommas = (x) => {
  const parts = x.toString().split(".")
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  // if decimal part is zero-only then remove it (for swe standart)
  return parts[1] === "00" ? parts[0] : parts.join(",")
}
